import PagesRequiringUserRecord from './PagesRequiringUserRecord'

export default PagesRequiringUserRecord
